// import allah from "../assets/images/allah-logo.png";
// import allah1 from "../assets/images/allah-logo1.svg";
import hscLogo from "../assets/images/hsc-logo.svg";
import hscLogoText from "../assets/images/hsc-logo-text.svg";
const SplashScreen = () => {
  return (
    <div className="splash-screen">
      <b>1</b>
      <b>2</b>
      <b>3</b>
      <div className="splash-screen__content u-margin-top-medium-5">
        <div className="splash-screen__content__img1 u-margin-bottom-small-3">
          <img src={hscLogo} alt="" />
        </div>
        <div className="splash-screen__content__img2">
          <img src={hscLogoText} alt="" />
        </div>
      </div>
      {/* <span>1</span>
      <span>2</span>
      <span>3</span>
      <div className="logo-holder">

        <img src={allah1} alt="splash-screen" />
      </div>
      <div className="atom-holder">
        <div className="atom-holder--1"> </div>
        <div className="atom-holder--2"> </div>
        <div className="atom-holder--3"> </div>
        <div className="atom-holder--4"> </div>
        <div className="atom-holder--5"> </div>
        <div className="atom-holder--6"> </div>
      </div> */}


      <div className="splash-screen__text">
        <span>Powered</span>
        <span>by</span>
        <div>
          <span>Va</span>
          <span>sl</span>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
